import {Injectable} from "@angular/core";
import {News} from "../+news/news.model";
import {ApiService} from "./api.service";
import {Headers} from "@angular/http";

@Injectable()
export class NewsService {

  constructor(private apiService: ApiService){}

  private newsUrl = '/api/news';

  getNews(){
    return this.apiService.get(this.newsUrl, { headers : new Headers({ 'Cache-Control': 'no-cache' }) })
      .map(res => res as News[]);
  }

}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/+app/shared/news.service.ts